import React, { PureComponent } from "react";
import styled from "styled-components";
import { EbrochureForm } from "../containers";

const Div = styled.div`
  width: 100%;
  height: 100%;
  background: #f4f4f5;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 30px;
`;

export default class EbrochureDownload extends PureComponent {
  render() {
    return (
      <Div>
        <EbrochureForm {...this.props} />
      </Div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/EbrochureDownload.js